<section id="secao-nossos-mentores">
  <div class="container">
    <div class="row py-4 r-titulo">
      <div class="col-md-6 col-sm-12">
        <h1 class="titulo w-100 text-center">Diretoria Executiva</h1>
      </div>
      <div class="col-md-6 col-sm-12 c-hr">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12" *ngFor="let c of diretoria">
        <div class="card mb-3">
          <div class="row r-card no-gutters">
            <div class="col-md-4 col-sm-4 c-foto text-center">
              <img
                *ngIf="c.imagens.length > 0"
                width="auto"
                height="120rem"
                width="120rem"
                class="rounded-circle foto"
                [src]="c.imagens[0].signedUrl"
              />
            </div>
            <div class="mentores col-sm-8">
              <div class="card-body align-itens-center">
                <h5 class="card-title">{{ c.nome }}</h5>
                <p class="card-text">{{ c.sobre }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
